import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../services/common";
import { getGroupAnalytics, processFBData } from "../services/activity";

export default function Reportprofile() {
  const { groupAnaytics } = useSelector((state) => {
    return state.Analytics;
  });
  const untilSelector = useSelector((state) => state.UntilDates);
  const sinceSelector = useSelector((state) => state.SinceDates);

  const [mapData, setMapData] = useState([{
    audience: 0, netAudience: 0, publishedPosts: 0, impression: 0, engagment: 0, engagment_impression: 0, video_views: 0, name: '', image_url: ""
  }])

  useEffect(() => {
    const facebookData = groupAnaytics?.FACEBOOK || [];
    const instagramData = groupAnaytics?.INSTAGRAM || [];
    const pinterestData = groupAnaytics?.PINTEREST || [];
  
    const fetchAllAnalytics = async () => {
      try {
        const formattedSince = formatDate(sinceSelector[0]);
        const formattedUntil = formatDate(untilSelector[0]);
  
        const previousSince = new Date(formattedSince);
        previousSince.setMonth(previousSince.getMonth() - 1);
  
        const previousUntil = new Date(formattedUntil);
        previousUntil.setMonth(previousUntil.getMonth() - 1);
  
        const processProfileData = ({
          name,
          image,
          engagement,
          impression,
          followerCount,
          previousFollowerCount = 1,
          postCount,
          videoCount,
        }) => {
          const safeImpression = impression || 1;
          const safePreviousFollowers = previousFollowerCount || 1;
  
          return {
            name,
            engagment: engagement,
            impression,
            netAudience: ((followerCount - safePreviousFollowers) / safePreviousFollowers) * 100,
            image,
            publishedPosts: postCount,
            video_views: videoCount,
            audience: followerCount,
            engagment_impression: engagement / safeImpression,
          };
        };
  
        const profilesDataInstaList = instagramData.map((profile) =>
          processProfileData({
            name: profile.profileName,
            image: profile.profilePicture,
            engagement: profile.totalEngagement,
            impression: profile.totalReach,
            followerCount: profile.followersCount,
            previousFollowerCount: profile.previousPeriod?.followersCount || 1,
            postCount: profile.postCount,
            videoCount: profile.videoCount,
          })
        );
  
        const profilesDataFbList = facebookData.map((profile) =>
          processProfileData({
            name: profile.pageName,
            image: profile.pagePicture,
            engagement: profile.totalEngagements,
            impression: profile.totalImpressions,
            followerCount: profile.followerCount,
            previousFollowerCount: profile.previousPeriod?.followerCount || 1,
            postCount: profile.postCount,
            videoCount: profile.videoCount,
          })
        );
  
        const profilesDataPinterestList = pinterestData.map((profile) =>
          processProfileData({
            name: profile.profileName,
            image: profile.profilePicture,
            engagement: profile.totalEngagements,
            impression: profile.totalImpressions,
            followerCount: profile.followersCount,
            previousFollowerCount: profile.previousPeriod?.followersCount || 1,
            postCount: profile.postCount,
            videoCount: profile.videoCount,
          })
        );
  
        setMapData([...profilesDataFbList, ...profilesDataInstaList, ...profilesDataPinterestList]);
      } catch (error) {
        console.error("Error fetching analytics:", error);
      }
    };
  
    fetchAllAnalytics();
  }, []);
  
console.log(mapData,'mapDatamapDatamapData');

  return (
    <>
      <div className="chart_section">
        <div className="chart_heading d-flex flex-column px-3 py-3">
          <label className="label_head">Profiles</label>

          <label className="label_sub_head">
            Review aggregate activity for pages and the posts published during
            the selected time period.
          </label>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table className="comp-profile-tbl table">
            <thead>
              <tr>
                <th style={{ width: "50%" }}>Profile</th>
                <th>Audience</th>
                <th className="text-right">Net Audience Growth</th>
                <th className="text-right">Published Posts</th>
                <th className="text-right">Impression</th>
                <th className="text-right">Engagements</th>
                <th className="text-right">
                  Engagements Rate (per Impression)
                </th>
                <th className="text-right">Video View</th>
              </tr>
            </thead>

            <tbody>
              {/* <tr>
                {/* <td className="pro-tbl-name1">
                  <div className="d-flex flex-column">
                    <span>Reporting Period</span>
                    <span className="report_dates">
                      Apr 1, 2023-Apr 30, 2023
                    </span>
                  </div>
                </td> */}
              {/* <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td> 

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column text-right">
                    <span>
                      <strong>1,129</strong>
                    </span>
                    <span className="report_dates rate_incr">2.1%</span>
                  </div>
                </td>
              </tr> */}

              <tr>
                <td className="pro-tbl-name1">
                  <div className="d-flex flex-column">
                    <span>Compare to</span>
                    <span className="report_dates">
                      {formatDate(sinceSelector[0])}  -  {formatDate(untilSelector[0])}
                    </span>
                  </div>
                </td>

              </tr>

                {mapData &&
                  mapData?.length > 0 &&
                  mapData?.map((data) => {
                    return (
                      <tr>
                      <>
                        <td>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div>1</div>
                            <div style={{ marginLeft: 10 }}>
                              <img
                                src={data?.image_url}
                                className="pro-img"
                              />
                            </div>
                            <div className="pro-tbl-name">{data?.name}</div>
                          </div>
                        </td>
                        <td>{data?.audience}</td>
                        <td>{data?.netAudience}</td>
                        <td>{data?.publishedPosts}</td>
                        <td>{data?.engagment}</td>
                        <td>{data?.impression}</td>
                        <td>{data?.engagment_impression}</td>
                        <td>{data.video_views}</td>
                      </>
              </tr>
                    );
                  })}




            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
